import React, { useState, useCallback } from 'react';
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import ReactFlow, {
  addEdge,
  MiniMap,
  Controls,
  Background,
  Handle,
} from 'reactflow';
import 'reactflow/dist/style.css';
import './custom.css';
const initialNodes = [
  {
    id: '1',
    type: 'input',
    data: { label: 'Incident' },
    position: { x: 200, y: 20 },
    className: 'grey-node',
  },
  {
    id: '2',
    data: { label: 'First Responder', value: '', onChange: () => {} },
    position: { x: 200, y: 100 },
  },
  {
    id: '3',
    data: { label: 'Inform SFP of Incident', value: '', onChange: () => {} },
    position: { x: 400, y: 100 },
    className: 'black-node',
  },
  {
    id: '4',
    data: { label: 'Stabilised' },
    position: { x: 50, y: 200 },
  },
  {
    id: '5',
    data: { label: 'Not Stabilised' },
    position: { x: 300, y: 200 },
  },
  {
    id: '6',
    type: 'customNode',
    data: { label: 'Call State Ambulance service (999)' },
    position: { x: 500, y: 240 },
  },
  {
    id: '7',
    data: { label: 'SFP to Notify Key Staff' },
    position: { x: 700, y: 180 },
    className: 'black-node',
  },
  {
    id: '8',
    data: { label: 'SFP Completes Incident Report' },
    position: { x: 50, y: 300 },
    className: 'green-node',
  },
  {
    id: '9',
    data: { label: 'Stabilised' },
    position: { x: 350, y: 350 },
  },
  {
    id: '10',
    data: { label: 'Not Stabilised' },
    position: { x: 600, y: 350 },
  },

  {
    id: '11',
    data: { label: 'SFP Completes Incident Report' },
    position: { x: 350, y: 450 },
    className: 'green-node',
  },
  {
    id: '12',
    data: { label: 'Medical Facility' },
    position: { x: 600, y: 450 },
  },
  {
    id: '13',
    data: { label: 'SFP to Help Determine which Medical Facility' },
    position: { x: 800, y: 450 },
    className: 'black-node',
  },
];

const initialEdges = [
  {
    id: 'e1-2',
    source: '1',
    target: '2',
    type: 'smoothstep',
    style: { stroke: 'red' },
    markerEnd: { type: 'arrowclosed' },
  },
  {
    id: 'e2-3',
    source: '2',
    target: '3',
    type: 'straight',
    style: { stroke: 'black' },
    markerEnd: { type: 'arrowclosed' },
  },
  {
    id: 'e2-4',
    source: '2',
    target: '4',
    type: 'straight',
    style: { stroke: 'green' },
    markerEnd: { type: 'arrowclosed' },
  },
  {
    id: 'e2-5',
    source: '2',
    target: '5',
    type: 'straight',
    style: { stroke: 'red' },
    markerEnd: { type: 'arrowclosed' },
  },
  {
    id: 'e4-8',
    source: '4',
    target: '8',
    type: 'smoothstep',
    style: { stroke: 'green' },
    markerEnd: { type: 'arrowclosed' },
  },
  {
    id: 'e5-6',
    source: '5',
    target: '6',
    type: 'straight',
    style: { stroke: 'red' },
    markerEnd: { type: 'arrowclosed' },
  },
  {
    id: 'e6-7',
    source: '6',
    target: '7',
    type: 'straight',
    style: { stroke: 'black' },
    markerEnd: { type: 'arrowclosed' },
  },
  {
    id: 'e6-9',
    source: '6',
    target: '9',
    type: 'smoothstep',
    style: { stroke: 'green' },
    markerEnd: { type: 'arrowclosed' },
  },
  {
    id: 'e6-10',
    source: '6',
    target: '10',
    type: 'smoothstep',
    style: { stroke: 'red' },
    markerEnd: { type: 'arrowclosed' },
  },
  {
    id: 'e9-11',
    source: '9',
    target: '11',
    type: 'smoothstep',
    style: { stroke: 'green' },
    markerEnd: { type: 'arrowclosed' },
  },
  {
    id: 'e10-12',
    source: '10',
    target: '12',
    type: 'smoothstep',
    style: { stroke: 'red' },
    markerEnd: { type: 'arrowclosed' },
  },
  {
    id: 'e12-13',
    source: '12',
    target: '13',
    type: 'smoothstep',
    style: { stroke: 'black' },
    markerEnd: { type: 'arrowclosed' },
  },
];

export default function FlowchartSection1({
  medicalEmergency,
  setMedicalEmergency,
  nodeTypes1,
}) {
  const handleInputChange = (id, value) => {
    setNodes((nds) =>
      nds.map((node) =>
        node.id === id ? { ...node, data: { ...node.data, value } } : node
      )
    );
    setMedicalEmergency((prevState) => ({
      ...prevState,
      information: value,
    }));
  };

  const [nodes, setNodes, onNodesChange] = useState(
    initialNodes.map((node) => ({
      ...node,
      data: {
        ...node.data,
        value: medicalEmergency.information,
        onChange: (value) => handleInputChange(node.id, value),
      },
    }))
  );
  const [edges, setEdges, onEdgesChange] = useState(initialEdges);

  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    [setEdges]
  );

  return (
    <div style={{ width: '100%', height: '70vh' }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        nodeTypes={nodeTypes1}
        panOnScroll={false}
        panOnDrag={false}
        zoomOnScroll={false}
        zoomOnPinch={false}
        zoomOnDoubleClick={false}
        attributionPosition={null}
        interactionMode="nodeDrag"
        preventScrolling={false}
      ></ReactFlow>
    </div>
  );
}
